import styled from 'styled-components';
import { getColor } from 'utils/helpers/styleHelpers';

export const SLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const STitle = styled.div`
  font-size: 31px;
  font-weight: 400;
  text-align: center;
  color: rgb(53, 49, 49);
  margin-bottom: 60px;
`;

export const SDescription = styled.div`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 40px;
`;

export const SVerifyRow = styled.div`
  display: flex;
  margin-bottom: 120px;
`;

export const SVerifyText = styled.div`
  display: flex;
  font-size: 18px;
  margin-left: 10px;
  color: rgba(0, 0, 0, 0.45);
`;

export const SVerifyVal = styled.span`
  margin-left: 10px;
  color: ${getColor('black')};
`;

export const SSubmitError = styled.div`
  text-align: center;
  font-size: 1.2em;
  color: red;
  margin-bottom: 18px;
`; 